// 선택 입력 설문 번호 목록 (survey_seq 기준, 유효성 검사 제외)
export const OPTIONAL_SURVEY_SEQS = ['4', '5'];

const isUnanswered = (q, answers) => {
    const a = answers[q.surveySeq];
    if (q.answerType === 'TEXT')     return !a || a.trim() === '';
    if (q.answerType === 'RADIO')    return !a || a === '' || a === '0';
    if (q.answerType === 'CHECKBOX') return !a || a.length === 0;
    return false;
};

/**
 * 미입력된 첫 번째 필수 설문의 index 반환
 * @returns {number} 미입력 첫 번째 질문의 index, 모두 입력됐으면 -1
 */
export const findFirstUnanswered = (questions, answers) => {
    for (let i = 0; i < questions.length; i++) {
        const q = questions[i];
        if (OPTIONAL_SURVEY_SEQS.includes(String(q.surveySeq))) continue;
        if (isUnanswered(q, answers)) return i;
    }
    return -1;
};

/**
 * 미입력된 모든 필수 설문의 surveySeq 배열 반환
 * @returns {string[]} 미입력 질문의 surveySeq 목록
 */
export const getAllUnansweredSeqs = (questions, answers) => {
    return questions
        .filter(q => !OPTIONAL_SURVEY_SEQS.includes(String(q.surveySeq)) && isUnanswered(q, answers))
        .map(q => q.surveySeq);
};
